import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Gift, Ticket, CreditCard, User } from 'lucide-react';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: '/home', icon: Home, label: 'Home' },
    { path: '/rewards', icon: Gift, label: 'Rewards' },
    { path: '/card', icon: CreditCard, label: 'My Card' },
    { path: '/redemptions', icon: Ticket, label: 'Redemptions' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-md mx-auto">
        <div className="flex items-center justify-around">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex-1 flex flex-col items-center py-3 transition-colors ${
                  isActive(item.path)
                    ? 'text-buggy-blue'
                    : 'text-gray-400 hover:text-buggy-gray'
                }`}
              >
                <Icon size={24} strokeWidth={2} />
                <span className="text-xs font-medium mt-1">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
